import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";

import { formatPhoneNumber } from "../../../utils/helpers";

import s from "./styles.scss";
import IUser from "../../../types/services/IUser";

export type DonorChatTitleVariant = "thread" | "mobileToolbar";

interface Props {
  donor: IUser;
  showDonorDetail: (id: string) => void;
  variant: DonorChatTitleVariant;
  embedInChatHeaderRow?: boolean;
}

class DonorChatTitle extends React.PureComponent<Props> {
  goToContact = (): void => {
    this.props.showDonorDetail(this.props.donor.id);
  };

  onContactKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.goToContact();
    }
  };

  render() {
    const { donor, variant, embedInChatHeaderRow } = this.props;
    const title = donor.name
      ? donor.name
      : formatPhoneNumber(donor.phoneNumber);
    const wrapClass =
      variant === "mobileToolbar"
        ? s.wrapMobile
        : classNames(
            s.wrapThread,
            embedInChatHeaderRow && s.wrapThreadEmbed
          );
    const contactTipId = `donor-chat-contact-${donor.id}`;
    return (
      <div className={wrapClass}>
        <div
          className={s.contactDetailsHit}
          onClick={this.goToContact}
          role="button"
          onKeyDown={this.onContactKeyDown}
          tabIndex={0}
          data-tip
          data-for={contactTipId}
          aria-label="Go to contact details"
        >
          <i
            className={
              "fa fa-user-circle " + s.selectedUserIcon + " " + s.selectedPhoto
            }
          />
          <span className={s.donorTitle}>{title}</span>
        </div>
        <ReactTooltip
          id={contactTipId}
          type="info"
          place="bottom"
          effect="float"
        >
          Go to contact details
        </ReactTooltip>
      </div>
    );
  }
}

export default withStyles(s)(DonorChatTitle);
